export default "__VITE_ASSET__CUp4hx5y__"